import { createGlobalStyle } from "../theme";

export default createGlobalStyle`
  html{
    height: 100vh;
  }

  html,body {
    margin: 0px;
    padding: 0px;
    background-color: white;
  }

  body {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
`;
